import {ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {IVideocall} from "../../../../models/videocall/i-videocall";
import {DEBUG, DebugService} from "../../../../services/debug.service";
import {VideocallMessageType} from "../../../../models/videocall/videocall-message-type";
import {IVideocallConfig} from "../../../../models/videocall/i-videocall-confi";
import {ScriptService} from "../../../../services/scripts/script-service";
import {Utils} from "../../../../utils";

@Component({
  selector: 'app-videocall-babylon',
  templateUrl: './videocall-babylon.component.html',
  styleUrls: ['./videocall-babylon.component.scss']
})
export class VideocallBabylonComponent implements OnInit, IVideocall {

  @Output()
  onMessage = new EventEmitter<{ eventType: VideocallMessageType, data?: string }>();

  @ViewChild('videocall', { static: false})
  videocall: any;

  started: boolean;

  constructor(
    private scriptService: ScriptService,
    private debugService: DebugService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
  }

  async prepareVideocall(): Promise<void> {
    /* Nothing to do */
    this.debugService.log(DEBUG.VIDEOCALL_BABYLON_MODULE, 'Preparation completed');
  }

  async startVideocall(): Promise<void> {
    this.debugService.log(DEBUG.VIDEOCALL_BABYLON_MODULE, 'Videocall module started');
    this.started = true;
  }

  /**
   * Messages FROM module
   **/

  async onModuleMessage(msg: string): Promise<void> {

    this.debugService.log(DEBUG.VIDEOCALL_UNITY_MODULE, `New message from module: ${msg}`);

    // Take only first parts of msg: 'part0;part1'
    const msgParts = msg.split(';');
    msg = `${msgParts[0]};${msgParts[1]}`;

    switch (msg) {
      case VideocallMessageType.MODULE_LOADED:
        this.onMessage.emit({ eventType: VideocallMessageType.MODULE_LOADED });
        break;
      case VideocallMessageType.MODULE_SCENE_LOADED:
        this.onMessage.emit({ eventType: VideocallMessageType.MODULE_SCENE_LOADED });
        break;
      case VideocallMessageType.CALL_STARTED:
        this.onMessage.emit({ eventType: VideocallMessageType.CALL_STARTED });
        break;
      case VideocallMessageType.CALL_NEW_CONNECTION:
        this.onMessage.emit({ eventType: VideocallMessageType.CALL_NEW_CONNECTION });
        break;
      case VideocallMessageType.CALL_DISCONNECTED:
        this.onMessage.emit({ eventType: VideocallMessageType.CALL_DISCONNECTED });
        break;
      case VideocallMessageType.CALL_RECORD_STARTED:
        this.onMessage.emit({ eventType: VideocallMessageType.CALL_RECORD_STARTED });
        break;
      case VideocallMessageType.CALL_RECORD_STOPPED:
        this.onMessage.emit({ eventType: VideocallMessageType.CALL_RECORD_STOPPED });
        break;
      case VideocallMessageType.ANNOTATION_TEXT:
        this.onMessage.emit({ eventType: VideocallMessageType.ANNOTATION_TEXT });
        break;
      case VideocallMessageType.CALL_CLOSED:
        // TODO: possible bug with mobile: it is sending 'close' and not 'dm;close'
        this.onMessage.emit({ eventType: VideocallMessageType.CALL_CLOSED });
        break;
      case VideocallMessageType.MODULE_UNLOADED:
        this.onMessage.emit({ eventType: VideocallMessageType.MODULE_UNLOADED });
        break;
      default:
        this.debugService.error(DEBUG.VIDEOCALL_UNITY_MODULE, `Message from module not handled: ${msg}`);
    }

  }

  /**
   * Messages TO module
   **/

  async goToExpert(): Promise<void> {
    while (!this.videocall) {
      await Utils.sleep(100);
    }
    this.sendToModule(null, 'GoToExpert', '');
  }

  startScotty(config: IVideocallConfig): void {

    // Add extra parameter
    config.offerer = false;

    this.sendToModule(null, 'StartScotty', JSON.stringify(config));
  }

  closeCall(): void {
    this.sendToModule(null, 'CloseCall', '');
  }

  unityQuit(): void {
    this.sendToModule(null, 'UnityQuit', '');
  }

  freeze(): void {
    this.sendToModule(null, 'Freeze', '');
  }

  unfreeze(): void {
    this.sendToModule(null, 'Unfreeze', '');
  }

  enrichText(data: string): void {
    this.sendToModule(null, 'EnrichText', data);
  }

  cancelText(): void {
    this.sendToModule(null, 'CancelText', '');
  }

  selectArrow(data: string): void {
    this.sendToModule(null, 'SelectArrow', data);
  }

  selectShape(data: string): void {
    this.sendToModule(null, 'SelectShape', data);
  }

  showMeasurements(): void {
    this.sendToModule(null, 'ShowMeasurements', '');
  }

  hideMeasurements(): void {
    this.sendToModule(null, 'HideMeasurements', '');
  }

  selectFreedraw(data: string): void {
    this.sendToModule(null, 'SelectFreedraw', data);
  }

  selectText(): void {
    this.sendToModule(null, 'SelectText', '');
  }

  clear(): void {
    this.sendToModule(null, 'Clear', '');
  }

  setMute(muted: boolean): void {
    this.sendToModule(null, 'SetMute', muted.toString());
  }

  addImage(url: string): void {
    this.sendToModule(null, 'AddImage', url);
  }

  addModel(url: string): void {
    this.sendToModule(null, 'AddModel', url);
  }

  addPdf(url: string): void {
    this.sendToModule(null, 'AddPdf', url);
  }

  takeScreenshot(): void {
    this.sendToModule(null, 'RequestCompleteScreenshot', '');
  }

  directMessage(message: string): void {
    this.sendToModule(null, 'DirectMessage', message);
  }

  notifyRecording(data: string): void {
    this.sendToModule(null, 'NotifyRecording', data);
  }

  // TODO not working, fix module?
  forceResize(): void {
    this.sendToModule(null, 'ForceResize', '');
  }

  sendToModule(_: string, method: string, data: string): void {
    const _data = [method, data];
    this.debugService.log(DEBUG.VIDEOCALL_BABYLON_MODULE, `Sending message to module: ${_data.filter(x => !!x).join(', ')}`);
    this.videocall.nativeElement.sendMessage(..._data);
  }

}
